import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { Transition } from 'react-transition-group';

// Components
import ClickOutHandler from '../../OnClickOut';
import Lang from '../Lang';

// Styles
import styles from './DesktopView.styl';

const cx = classNames.bind(styles);

export default function DesktopView(props) {
  const { className, onLocaleChange, currentLocale, locales } = props;

  const [isOpen, setIsOpen] = useState(false);

  const handleOnToggle = () => {
    setIsOpen(prev => !prev);
  };

  const handleOnLocaleChange = newLocale => {
    onLocaleChange(newLocale);
    setIsOpen(false);
  };

  return (
    <div className={cx('LangSwitcher', className)}>
      <Lang onLocaleClick={handleOnToggle} locale={currentLocale} />
      <Transition in={isOpen} timeout={{ enter: 175, exit: 0 }} mountOnEnter unmountOnExit>
        {state => (
          <ClickOutHandler onClickOut={handleOnToggle}>
            <div className={cx('LangSwitcher__dropdown', `LangSwitcher__dropdown_${state}`)}>
              {locales.map(locale => (
                <Lang
                  key={locale}
                  locale={locale}
                  onLocaleClick={handleOnLocaleChange}
                  isActive={locale === currentLocale}
                />
              ))}
            </div>
          </ClickOutHandler>
        )}
      </Transition>
    </div>
  );
}

DesktopView.defaultProps = {
  className: '',
};

DesktopView.propTypes = {
  className: PropTypes.string,
  currentLocale: PropTypes.string.isRequired,
  onLocaleChange: PropTypes.func.isRequired,
  locales: PropTypes.array.isRequired,
};
